// ================== Collapse Motion ==================
import {prefix} from "../../../wui-core/src/index";
import React from 'react';

const getCollapsedHeight = () => ({height: 0, opacity: 0});
const getRealHeight = (node: HTMLElement) => ({height: node.scrollHeight, opacity: 1});
const getCurrentHeight = (node: HTMLElement) => ({height: node.offsetHeight});
const skipOpacityTransition = (_: any, event: any) =>
    event.propertyName === 'height';

const collapseMotion = {
    motionName: `${prefix}-motion-collapse`,
    onAppearStart: getCollapsedHeight,
    onEnterStart: getCollapsedHeight,
    onAppearActive: getRealHeight,
    onEnterActive: getRealHeight,
    onLeaveStart: getCurrentHeight,
    onLeaveActive: getCollapsedHeight,
    onAppearEnd: skipOpacityTransition,
    onEnterEnd: skipOpacityTransition,
    onLeaveEnd: skipOpacityTransition,
    motionDeadline: 500,
};

const getTransitionName = (rootPrefixCls: string, motion: string, transitionName: string) => {
    if (transitionName !== undefined) {
        return transitionName;
    }
    return `${rootPrefixCls}-${motion}`;
};
export {getTransitionName};

/**
 * 获取元素的文本内容
 * @param element React元素或DOM元素
 * @returns 文本内容
 */
export const getElementText = (element: React.ReactNode): string => {
    // 处理空值情况
    if (element == null) {
        return '';
    }

    // 处理字符串和数字
    if (typeof element === 'string' || typeof element === 'number') {
        return String(element);
    }

    // 处理数组
    if (Array.isArray(element)) {
        return element.map(item => getElementText(item)).join('');
    }

    // 处理React元素
    if (React.isValidElement(element)) {
        const { props } = element;

        // 处理children
        if (props.children) {
            return getElementText(props.children);
        }
    }

    // 处理DOM元素
    if (element instanceof HTMLElement) {
        return element.textContent || '';
    }

    // 处理其他情况
    return String(element);
};
export default collapseMotion;
